import axios from 'axios'

export const getCategories = (params) => {
  return axios.get('categories', { params: params })
}



// WEBPACK FOOTER //
// ./src/api/categories.js